import { gsap } from "../../animations/gsapSetup.ts";
import { useGsapScrollTrigger } from "../../hooks/useGsapScrollTrigger.ts";
import { useIsMobile } from "../../hooks/useMediaQuery.ts";
import { useReducedMotion } from "../../hooks/useReducedMotion.ts";
import { useI18n } from "../../i18n/context.tsx";
import styles from "./EverythingInClassic.module.css";

export function EverythingInClassic() {
  const reducedMotion = useReducedMotion();
  const isMobile = useIsMobile();
  const { t } = useI18n();

  const ref = useGsapScrollTrigger(
    (el) => {
      if (reducedMotion) return;

      const items = el.querySelectorAll(`.${styles.item}`);
      const plus = el.querySelector(`.${styles.plusTransition}`);

      if (isMobile) {
        gsap.from(items, {
          y: 30,
          opacity: 0,
          duration: 0.6,
          stagger: 0.08,
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        });
        gsap.from(plus, {
          y: 20,
          opacity: 0,
          duration: 0.6,
          delay: 0.6,
          scrollTrigger: {
            trigger: plus,
            start: "top 90%",
            toggleActions: "play none none reverse",
          },
        });
      } else {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: el,
            start: "top 70%",
            toggleActions: "play none none reverse",
          },
        });

        tl.from(items, {
          y: 40,
          opacity: 0,
          duration: 0.7,
          stagger: 0.1,
          ease: "power3.out",
        }).from(
          plus,
          {
            y: 20,
            opacity: 0,
            duration: 0.8,
            ease: "power3.out",
          },
          "-=0.2",
        );
      }
    },
    [isMobile],
  );

  return (
    <section ref={ref} className={styles.section}>
      <div className={styles.content}>
        <h2 className={styles.title}>{t.ai.everythingTitle}</h2>
        <div className={styles.grid}>
          {t.ai.everythingFeatures.map((feature) => (
            <div key={feature.title} className={styles.item}>
              <span className={styles.icon}>{feature.icon}</span>
              <h3 className={styles.itemTitle}>{feature.title}</h3>
              <p className={styles.itemDescription}>{feature.desc}</p>
            </div>
          ))}
        </div>
        <p className={`${styles.plusTransition} ${reducedMotion ? styles.plusVisible : ""}`}>
          {t.ai.everythingPlus}
        </p>
      </div>
    </section>
  );
}
